
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Content Editor</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" id="html-modal-content">
  
  <app-text-or-html [isInModal]="true" [(value)]="inProgressHtml" [maxLength]="maxLength"></app-text-or-html>
  
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="discard()" color="medium">
        Cancel
      </ion-button>
      <ion-button (click)="revert()" color="medium">
        Revert
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="apply()" color="primary">
        Apply and Close
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>